(function ($) {
  'use strict';

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function highlight(title, keyword) {
    var pattern = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var expression = new RegExp(pattern, 'gi');
    var output = '', offset = 0;
    title.replace(expression, function (match, index) {
      output += escapeHtml(title.slice(offset, index)) + '<span class="marked">' + escapeHtml(match) + '</span>';
      offset = index + match.length;
      return match;
    });
    return output + escapeHtml(title.slice(offset));
  }

  function initialise(input) {
    var field = $(input), box = field.closest('.searchbox');
    var wrapper = box.find('.result-ajax-search').first();
    var results = wrapper.children('.search-results');
    var timer, request, generation = 0, dismissed = false;
    if (!results.length) return;
    results.attr('aria-live', 'polite');

    function invalidate() {
      generation++;
      clearTimeout(timer);
      if (request) {
        request.abort();
        request = null;
      }
      box.removeClass('s-loading');
      field.attr('aria-busy', 'false');
    }

    function message(text) {
      results.empty().append($('<li class="result-item">').append($('<p>').text(text)));
      wrapper.show();
    }

    function search() {
      invalidate();
      dismissed = false;
      results.empty();
      wrapper.hide();
      var keyword = $.trim(field.val());
      if (!keyword) return;
      if (keyword.length < 2) {
        message('You must enter at least 2 characters.');
        return;
      }
      var current = generation;
      timer = setTimeout(function () {
        box.addClass('s-loading');
        field.attr('aria-busy', 'true');
        request = $.ajax({
          type: 'GET',
          url: field.closest('form').attr('action') || '/search',
          data: { q: keyword, type: 'product', view: 'json', sort_by: 'relevance' },
          dataType: 'json',
          timeout: 15000,
          success: function (items) {
            if (current !== generation || dismissed || $.trim(field.val()) !== keyword) return;
            if (!Array.isArray(items)) {
              message('Search is temporarily unavailable. Press Enter to search.');
              return;
            }
            results.empty();
            if (!items.length) {
              message('No result found for your search.');
              return;
            }
            items.forEach(function (item) {
              var row = $('<li class="result-item">');
              var url = String(item.handle || '');
              if (url.charAt(0) !== '/' || url.charAt(1) === '/') return;
              if (item.featured_image) {
                $('<a class="search-item-img">').attr('href', url).append(
                  $('<img style="max-width:100px;float:left;">').attr({ src: item.featured_image, alt: item.title || '' })
                ).appendTo(row);
              }
              $('<a class="search-item-title">').attr('href', url).html(highlight(String(item.title || ''), keyword)).appendTo(row);
              if (item.available && item.has_compare_price) {
                $('<span class="price-compare">').html(item.compare_price).appendTo(row);
              }
              $('<span>').addClass((item.has_compare_price ? 'price-sale' : 'price') + (item.available ? '' : ' sold-out')).html(
                item.available ? item.price : escapeHtml(item.out_stock_nofication)
              ).appendTo(row);
              results.append(row);
            });
            wrapper.show();
            if (typeof window.currenciesCallbackSpecial === 'function') {
              window.currenciesCallbackSpecial(results.find('span.money'));
            }
          },
          error: function (_xhr, status) {
            if (current === generation && !dismissed && status !== 'abort') {
              message('Search is temporarily unavailable. Press Enter to search.');
            }
          },
          complete: function () {
            if (current !== generation) return;
            request = null;
            box.removeClass('s-loading');
            field.attr('aria-busy', 'false');
          }
        });
      }, 300);
    }

    field.on('input.rzAjaxSearch', search);
    field.on('keydown.rzAjaxSearch', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        dismissed = true;
        invalidate();
        wrapper.hide();
      }
    });
    field.on('focus.rzAjaxSearch', function () {
      if (dismissed && $.trim(field.val()).length >= 2) search();
      else if (results.children().length) wrapper.show();
    });
    $(document).on('pointerdown.rzAjaxSearch', function (event) {
      if (box[0].contains(event.target)) return;
      dismissed = true;
      invalidate();
      wrapper.hide();
    });
    box.on('focusout.rzAjaxSearch', function () {
      setTimeout(function () {
        if (!box[0].contains(document.activeElement)) {
          dismissed = true;
          invalidate();
          wrapper.hide();
        }
      }, 0);
    });
    field.closest('form').on('submit.rzAjaxSearch', function () {
      dismissed = true;
      invalidate();
      wrapper.hide();
    });
  }

  $(function () {
    $('.bc-product-search').each(function () { initialise(this); });
  });
})(jQuery);